import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function AboutSection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      label: 'THE ARTIST',
      headline: 'Art That Lives On Your Skin',
      bio1: 'I am a Cuban-born fine art tattoo artist now based in Miami, FL since 2022.',
      bio2: 'I graduated from the Academy of Plastic Arts with a specialization in Painting — a foundation that permanently shaped the way I see light, shadow, composition and form.',
      bio3: 'I have been tattooing since 2018, dedicating my practice exclusively to black and white realism — a discipline that demands the same precision, patience and artistic sensitivity as fine art painting.',
      bio4: 'For me, every tattoo is a painting. Not on canvas. On skin. And it lasts forever.'
    },
    es: {
      label: 'EL ARTISTA',
      headline: 'Arte Que Vive En Tu Piel',
      bio1: 'Soy un artista cubano radicado en Miami, FL desde 2022.',
      bio2: 'Me gradué de la Academia de Artes Plásticas con especialidad en Pintura — una base que definió para siempre mi manera de ver la luz, la sombra, la composición y la forma.',
      bio3: 'Tatúo desde 2018, dedicando mi práctica exclusivamente al realismo blanco y negro — una disciplina que exige la misma precisión, paciencia y sensibilidad artística que la pintura fine art.',
      bio4: 'Para mí, cada tatuaje es una pintura. No en lienzo. En piel. Y dura para siempre.'
    }
  };
  const t = content[language];
  return <section className="py-12 md:py-16 px-6 relative border-b border-brand-gold/30" data-id="element-2">
      <div className="max-w-7xl mx-auto" data-id="element-3">
        <motion.div className="mb-8 md:mb-12 text-center md:text-left" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-4">
          <span className="text-brand-gold font-sans text-sm tracking-[0.3em] uppercase block mb-4" data-id="element-5">
            {t.label}
          </span>
          <h2 className="text-4xl md:text-6xl font-serif text-brand-gold" data-id="element-6">
            {t.headline}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-7">
          <motion.div className="relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-8">
            <div className="aspect-[3/4] w-full max-w-md mx-auto relative gold-border-glow p-2" data-id="element-9">
              <div className="w-full h-full bg-brand-charcoal flex items-center justify-center overflow-hidden" data-id="element-10">
                {/* Placeholder for Artist Photo */}
                <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/rRF7fCCJSGytE7T4waW44k/IMG_2122.png')] bg-cover bg-center opacity-80" data-id="element-11" />
                <span className="relative z-10 font-serif text-brand-gold text-2xl tracking-widest opacity-50" data-id="element-12">
                  KRLY
                </span>
              </div>
            </div>
            <p className="text-center text-brand-gold font-sans text-xs tracking-widest uppercase mt-3" data-id="element-13">
              KRLY — Miami, FL
            </p>
          </motion.div>

          <motion.div className="space-y-4 text-brand-white font-sans font-light text-lg leading-relaxed" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-14">
            <p data-id="element-15">{t.bio1}</p>
            <p data-id="element-16">{t.bio2}</p>
            <p data-id="element-17">{t.bio3}</p>
            <p className="text-brand-gold font-serif text-2xl italic mt-4" data-id="element-18">
              "{t.bio4}"
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}